<router-outlet></router-outlet>

<p-toast key="main-toast" position="bottom-center" />